import { useState } from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../../../util/brand";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="home-header">
      <div className="nav">
        <Link to="/" className="logo font-bold text-xl text-blue-700">
          {APP_NAME}
        </Link>
        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          <ul className="flex gap-6 items-center">
            <li>
              <a href="#features" className="hover:text-blue-600">
                Features
              </a>
            </li>
            <li>
              <a href="#demo" className="hover:text-blue-600">
                Demo
              </a>
            </li>
            <li>
              <a href="#pricing" className="hover:text-blue-600">
                Pricing
              </a>
            </li>
            <li>
              <a
                href="https://www.videomarketer.com/"
                className="hover:text-blue-600"
                target="_blank"
                rel="noreferrer"
              >
                Blog
              </a>
            </li>
          </ul>
        </nav>
        <nav className="hidden md:flex items-center gap-8">
          <div className="nav-cta flex gap-2 ml-6">
            <Link to="/login" className="btn btn-secondary">
              Sign In
            </Link>
            <Link to="/register" className="btn btn-primary">
              Start Free Trial
            </Link>
          </div>
        </nav>
        {/* Hamburger for mobile */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 rounded hover:bg-gray-100"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Open menu"
        >
          <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
            <path
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
        {/* Dropdown menu for mobile */}
        {menuOpen && (
          <div className="absolute top-full right-4 mt-2 w-56 bg-white rounded-lg shadow-lg border z-50 flex flex-col md:hidden">
            <a
              href="#features"
              className="px-5 py-3 text-[#2563eb] font-medium hover:bg-gray-100"
              onClick={() => setMenuOpen(false)}
            >
              Features
            </a>
            <a
              href="#demo"
              className="px-5 py-3 text-[#2563eb] font-medium hover:bg-gray-100"
              onClick={() => setMenuOpen(false)}
            >
              Demo
            </a>
            <a
              href="#pricing"
              className="px-5 py-3 text-[#2563eb] font-medium hover:bg-gray-100"
              onClick={() => setMenuOpen(false)}
            >
              Pricing
            </a>
            <a
              href="https://www.videomarketer.com/"
              className="px-5 py-3 text-[#2563eb] font-medium hover:bg-gray-100"
              onClick={() => setMenuOpen(false)}
              target="_blank"
              rel="noreferrer"
            >
              Blog
            </a>
            <Link
              to="/login"
              className="px-5 py-3 text-[#2563eb] font-medium hover:bg-gray-100"
              onClick={() => setMenuOpen(false)}
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="px-5 py-3 text-[#2563eb] font-medium rounded-b-lg hover:bg-blue-700 transition"
              onClick={() => setMenuOpen(false)}
            >
              Start Free Trial
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
